import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ChargeListComponent } from './charge-list/charge-list.component';
import { ChargeFormComponent } from './charge-form/charge-form.component';

const routes:Routes=[
  {
    path:'',
    data:{
      title:'Charge'
    },
    component:ChargeListComponent
  },
  {
    path:'',
    data:{
      title:'Charge'
    },
    component:ChargeListComponent
  },
  {
    path:'add',
    data:{
      title:'Add Charge'
    },
    component:ChargeFormComponent
  },
  {
    path:'edit/:id',
    data:{
      title:'Edit Charge'
    },
    component:ChargeFormComponent
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class ChargeRoutingModule { }
